import { render, staticRenderFns } from "./NotificationListGridFooter.vue?vue&type=template&id=23453166"
import script from "./NotificationListGridFooter.vue?vue&type=script&lang=js"
export * from "./NotificationListGridFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports